/** Inline UAE flag rendered in pure CSS divs */
export default function UAEFlag({ width = 28 }) {
  const height = Math.round(width * 0.64);
  return (
    <div style={{
      display: 'flex', width, height,
      borderRadius: 3, overflow: 'hidden', flexShrink: 0,
    }}>
      {/* Red vertical stripe */}
      <div style={{ width: '25%', background: '#EF3340', height: '100%' }} />
      {/* Three horizontal stripes */}
      <div style={{ width: '75%', display: 'flex', flexDirection: 'column' }}>
        <div style={{ flex: 1, background: '#009A44' }} />
        <div style={{ flex: 1, background: '#FFFFFF' }} />
        <div style={{ flex: 1, background: '#000000' }} />
      </div>
    </div>
  );
}
